<template>
  <!-- scanEntry >>> 微信表单 by lbj-->
  <div class="page">
    <van-overlay :show="showOverlay"
                 class-name="sava_Overlay"
                 z-index="9999">
      <div class="wrapper">
        <van-loading color="#1989fa"
                     vertical
                     text-color="#1989fa">加载中...</van-loading>
      </div>
    </van-overlay>
    <div v-show="loading"
         class="loading">
      <van-loading color="#1989fa" />
    </div>
    <div class="pp">
      <!-- <div v-show="showPersonal"
      class="register_title">个人信息</div>-->
      <div class="input_box">
        <!-- 基本信息 -->
        <wxForm ref="wxForm"
                :acceptid="acceptid"
                :addApiData="baseinfo"
                :moduleno="moduleNo"
                :status="status"
                :saveormodify="status"
                :module-config="moduleConfig"
                :masterformstr="''"
                :masterisactive="'1'"
                :tel="tel"
                :treeNodePre="treeNode"
                :mode="mode"
                :restype="restype"
                :localempid="localempid"
                :pageshow="pageshow"
                @getFormRecordData="getFormRecordData"
                @callBackFormRecordData="callBackFormRecordData"
                @writeSysTips="writeSysTips"
                @get="get"
                @updateformstr="updateformstr"
                @setCanSave="setCanSave"
                @setTx="setTx"
                @setSign="setSign"
                @changPage="changPage"
                @setIDCardphoToPic="setIDCardphoToPic"
                @refreshSonData="refreshSonData">
          <!-- 头像 -->
          <div v-if="showemppic || showcappic1 || showcappic2"
               v-show="showHead && moduleNo != '201'"
               slot="empPic"
               class="empPic">
            <!-- <div class="register_title">
              头像信息
              <van-icon name="user-o" @click="round=!round" :class="`tx ${round?'round':''}`" />
            </div>-->

            <div class="right_titlepar">
              <div class="right_title">
                <div style="width: 100%; text-align: center;">
                  <div>
                    头像信息
                    <van-icon name="user-o"
                              @click="round = !round"
                              :class="`tx ${round ? 'round' : ''}`" />
                  </div>
                </div>
                <div class="titlebtn"
                     @click="showEmppicture = !showEmppicture">
                  <svg-icon :icon-class="showEmppicture ? 'twodowngri' : 'twoupgr'" />
                </div>
              </div>
            </div>

            <div class="picbox"
                 v-show="showEmppicture">
              <div v-for="(item, index) in pic"
                   :key="index"
                   v-show="item.show">
                <van-image :round="round"
                           width="20vw"
                           height="20vw"
                           alt="1"
                           :src="item.src"
                           @click="openUpload(item)" />
                <div v-if="item.src"
                     @click="del(item)"
                     class="van-uploader__preview-delete">
                  <van-icon name="cross" />
                </div>

                <div>{{ item.name }}</div>
              </div>
              <van-uploader v-show="false"
                            ref="uploader"
                            v-model="fileList"
                            :lazy-load="true"
                            :max-count="1"
                            accept="image/*"
                            :capture="capture"
                            :max-size="10 * 1024 * 1024"
                            :before-read="beforeRead"
                            @oversize="onOversize"></van-uploader>
            </div>
          </div>
        </wxForm>
        <!-- 子表 -->
        <template v-if="dttableinfo.length > 0">
          <div v-for="(item, index) in dttableinfo"
               :key="index">
            <detail ref="detail"
                    :key="item.key"
                    v-show="item.show"
                    :info="{
                id: '4-' + index,
                moduleno: item.moduleno + '',
                masterkeyfield: item.masterkeyfield,
                dtkeyfield: item.dtkeyfield,
                detailtbname: item.detailtbname,
                acceptid: acceptid
              }"
                    :index="index"
                    :detailAtList="detailAtList"
                    @changPage="changPage" />
          </div>
        </template>

        <!-- 附表 -->
        <template v-if="attableinfo.length > 0">
          <detail v-for="(item, index) in attableinfo"
                  :key="index"
                  ref="detail"
                  :info="{
              id: '5-' + index,
              moduleno: item.moduleno + '',
              masterkeyfield: item.masterkeyfield,
              dtkeyfield: item.atbkeyfield,
              detailtbname: item.modulename,
              acceptid: acceptid
            }"
                  :index="dttableinfo.length + index" />
        </template>
      </div>
      <div v-if="pageshow == 1 || pageshow == '1'"
           class="page_bottom">
        <van-button plain
                    type="primary"
                    @click="showMenu = !showMenu">
          <template>
            <div style="display: flex;flex-direction: column;">
              <van-icon name="apps-o" />
              <div v-if="nav_btn_caption"
                   style="font-size:12px">{{nav_btn_caption}}</div>
            </div>
          </template>
        </van-button>
        <van-button v-if="!onlyOneMenu"
                    plain
                    class="addWidth"
                    type="primary"
                    @click="previousStep">上一步</van-button>
        <van-button v-show="!showSubmmitBtn"
                    v-if="!onlyOneMenu"
                    plain
                    class="addWidth"
                    type="primary"
                    @click="nextStep">下一步</van-button>
        <!-- {{ showSubmmitBtn }} -->
        <!-- :loading="btnLoad"
        loading-text="正在提交.."-->
        <van-button v-show="showSubmmitBtn || onlyOneMenu || !last_page_show_post_btn"
                    class="addWidth"
                    :class="`Sed bton op`"
                    type="info"
                    @click="b4save">提交</van-button>
      </div>
      <div v-else
           class="bottom">
        <!-- :loading="btnLoad"
        loading-text="正在提交.."-->
        <van-button :class="`Sed bton op`"
                    type="info"
                    @click="b4save">提交</van-button>
      </div>
    </div>
    <!-- 签名板 -->
    <van-overlay :show="show"
                 @click="show = false">
      <div style="width:100%;height:100%;"
           class="wrapper"
           @click.stop>
        <signaturePad ref="signaturePad"
                      @getSpad="getSpad"
                      @closeSpad="closeSpad"
                      :presigninfo="presigninfo"
                      :show="show"></signaturePad>
      </div>
    </van-overlay>
    <!-- 保存成功后提示板 -->
    <van-popup v-model="showPop"
               class="success_pop"
               position="right"
               :style="{ height: '100%', width: '100%' }">
      <div class="contant">
        <div class="suc_header">提交成功</div>
        <div class="suc_image">
          <img src="@/assets/img/resumeSuc.png"
               alt />
        </div>
        <div class="suc_name">
          <span>{{ empName }}</span>
          <span>您好！</span>
        </div>
        <div class="wuyong">
          {{postmsg?postmsg: (moduleNo == '201' ? '你的个人信息保存成功！' : moduleNo == '240'? '你的信息登记成功': '你的简历信息投递成功！')  }}
        </div>
        <div class="footer_btn">
          <div class="result_btn">
            <van-button color="#2B8DF0"
                        v-if="showJG"
                        @click="showResult">查看结果</van-button>
          </div>
          <div class="colser_btn">
            <span @click="colsePage">关闭</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 弹出分页菜单 -->
    <van-popup v-model="showMenu"
               class="showMenuPop"
               position="left"
               :style="{ height: '100%', width: '40%' }">
      <div class="sidContent">
        <van-sidebar v-model="sidebarActive">
          <van-sidebar-item v-for="(item, index) in menuList"
                            :key="index"
                            :title="item.name"
                            :class="[
              item.from != 'main' ? 'noMain_sid' : '',
              item.from == 'main' ? 'main_sid' : '',
              item.from == 'head' || (item.from == 'son' && item.sqlNum == 0)
                ? 'has_divider'
                : ''
            ]"
                            @click="changMenu(item)" />
        </van-sidebar>
      </div>
    </van-popup>

    <!-- loading -->
    <van-overlay :show="btnLoad"
                 z-index="2000">
      <div class="wrapper"
           style="display: flex; align-items: center; justify-content: center; height: 100%;"
           @click.stop>
        <van-loading type="spinner"
                     color="#2b8df0"
                     vertical
                     size="32px"
                     text-size="16px"
                     v-show="btnLoad">正在提交...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import wxForm from './wxForm.vue'
import detail from './detail.vue'
import signaturePad from '@components/signaturePad'
import { dataURLtoFile } from '@/utils'
import { Notify, Dialog } from 'vant'
import {
  getInfo as getbaseforminfo,
  upLoadBase64FileFixName,
  getQsTemplateOptionList_stationid,
  checkWxRsInputStatus,
  beforePostAllDtRecord,
  checkZpTestRes,
  getScanTestPaperInfo,
  beforePostScanEntry
} from '@/request/api.js'
import { Base64 } from 'js-base64'
export default {
  components: {
    wxForm,
    detail,
    signaturePad
  },
  data () {
    return {
      showJG: true, // 是否显示【查看结果】
      show: false, // 签名弹窗是否显示
      btnLoad: false,
      loading: true,
      haspic: false,
      sign: null,
      capture: 'camera', // 头像上传模式
      signstr: '',
      acceptid: '0',
      localempid: '0',
      localuserid: '0',
      mode: 'false',
      status: 'modify',
      moduleNo: '',
      restype: '',
      tel: '',
      baseinfo: { moduleconfiginfo: [{}] },
      moduleConfig: {},
      dttableinfo: [],
      attableinfo: [],
      treeNode: {},
      seStaList: ['304', '317', '319', '322'],
      fileList: [],
      selPic: null,
      round: true,
      pic: [
        { src: null, name: '证件照', type: 1, file: null, show: true },
        { src: null, name: '自拍照1', type: 2, file: null, show: true },
        { src: null, name: '自拍照2', type: 3, file: null, show: true }
      ],
      showEmppicture: true,
      showPop: false,
      empName: '',
      showMenu: false, // 是否显示左侧菜单
      sidebarActive: 0, // 选中的左侧导航的索引
      menuList: [], // 左侧导航数组
      showHead: false, // 是否显示头像信息
      // showPersonal: true, // 是否显示个人信息表头
      showSubmmitBtn: false, // 是否显示提交按钮
      pageshow: 0, // 配置文件是否启用分页
      usepresign: false, // 是否启用提交签名弹窗（配置文件）
      presigninfo: '', // 提交签名弹窗的提示文字（配置文件）
      showemppic: true, // (头像部分)是否显示证件照（1显示，0不显示）
      showcappic1: true, // (头像部分)是否显示自拍照1（1显示，0不显示）
      showcappic2: true, // (头像部分)是否显示自拍照2（1显示，0不显示）
      usedicfilename: false, // 允许主表附加字典类别显示；（1允许，0不允许）（配置文件）
      otherAtFileList: '',
      useMasterAtFile: false, // 表示允许字典附件在某个主表后显示；(前提是usedicfilename=1)
      detailAtList: [], // 子表的附件名列表
      autoPost: false, // 点击下一步或上一步（或左边切换时）是否启用自动保存，1保存，0不保存
      test_before_post: true, // 默认提交前填写问卷
      showOverlay: false, // 显示遮罩层
      hide_all_master_atfile: false, // 隐藏所有主表的附件信息,
      last_page_show_post_btn: false, // 是否只能在最后一页显示提交按钮,
      can_not_change_master_file: false, // 不允许更换主表附件----控制头像是否可更换
      postmsg: '', // beforePostScanEntry返回的提示信息
      nav_btn_caption: '', // 分页模式导航按钮文字
      change_next_page_mustinput: false, // 点下一页提醒对应的字段必填 
    }
  },
  computed: {
    // 当分页菜单只要一个时 不显示上一步和下一步按钮
    onlyOneMenu () {
      return this.menuList.length <= 1 ? true : false
    }
  },
  created () {
    // 获取路由参数
    let params = this.$route.query.param || {}
    if (Object.keys(params).length > 0)
    {
      params = JSON.parse(Base64.decode(params))
    }
    this.acceptid =
      params.autoid && params.autoid != 'null' ? params.autoid : '0'
    this.localempid =
      params.localempid && params.localempid != 'null' ? params.localempid : '0'
    this.localuserid =
      params.localuserid && params.localuserid != 'null'
        ? params.localuserid
        : '0'
    this.mode = params.mode ? params.mode + '' : 'false'
    this.status =
      params.autoid === '0' || params.autoid === '' || params.autoid === 'null'
        ? 'save'
        : 'modify'
    this.moduleNo = params.module
    this.restype = params.restype
    this.tel = params.tel

    this.getBaseForm()

    // 头像照片标题根据配置获取
    let emppic_title = '证件照'
    let cappic1_title = '自拍照1'
    let cappic2_title = '自拍照2'
    // 判断各模块的参数获取
    if (isNaN(Number(this.moduleNo)))
    {
      // 不是数字
      const mcommusepresign = window.comm ? window.comm.usepresign : ''
      if (mcommusepresign == 1)
      {
        this.usepresign = true
      } else
      {
        this.usepresign = false
      }
      const hide_query_result_btn = window.comm ? window.comm.usepresign : ''
      if (hide_query_result_btn == 1)
      {
        this.showJG = false
      } else
      {
        this.showJG = true
      }
      this.presigninfo = window.comm ? window.comm.presigninfo : ''
      const sp = window.comm ? window.comm.showemppic : ''
      const sp1 = window.comm ? window.comm.showcappic1 : ''
      const sp2 = window.comm ? window.comm.showcappic2 : ''

      if (sp == 1)
      {
        this.showemppic = true
      } else
      {
        this.showemppic = false
      }
      if (sp1 == 1)
      {
        this.showcappic1 = true
      } else
      {
        this.showcappic1 = false
      }
      if (sp2 == 1)
      {
        this.showcappic2 = true
      } else
      {
        this.showcappic2 = false
      }
      emppic_title = window.comm ? window.comm.emppic_title : ''
      cappic1_title = window.comm ? window.comm.cappic1_title : ''
      cappic2_title = window.comm ? window.comm.cappic2_title : ''
      const ap = window.comm ? window.comm.autoPost : ''
      if (ap == 1)
      {
        this.autoPost = true
      } else
      {
        this.autoPost = false
      }
      // 子表的附件名列表
      this.detailAtList = window.comm ? window.comm.detailAtList : []
      // 是否隐藏主表或者子表附件
      const hama = window.comm ? window.comm.hide_all_master_atfile : ''
      if (hama == 1)
      {
        this.hide_all_master_atfile = true
      } else
      {
        this.hide_all_master_atfile = false
      }
      const last_page_show_post_btn = window.comm
        ? window.comm.last_page_show_post_btn
        : ''
      if (last_page_show_post_btn == 1)
      {
        this.last_page_show_post_btn = true
      } else
      {
        this.last_page_show_post_btn = false
      }
      // 分页参数
      this.pageshow = window.comm ? window.comm.pageshow : null
      // 如果没有就用全局参数
      if (!this.pageshow && this.pageshow != 0)
      {
        this.pageshow = window.pageshow
      }
      // 不允许更换主表/子表附件
      const changeMFile = window.comm ? window.comm.can_not_change_master_file : ''
      if (changeMFile == 1)
      {
        this.can_not_change_master_file = true
      } else
      {
        this.can_not_change_master_file = false
      }
      this.nav_btn_caption = window.comm ? window.comm.nav_btn_caption : ''
      // 点下一页提醒对应的字段必填
      const change_next_page_mustinput = window.comm ? window.comm.change_next_page_mustinput : ''
      if (change_next_page_mustinput == 1)
      {
        this.change_next_page_mustinput = true
      } else
      {
        this.change_next_page_mustinput = false
      }
    } else
    {
      // 是数字
      const musepresign = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].usepresign
        : ''
      if (musepresign == 1)
      {
        this.usepresign = true
      } else
      {
        this.usepresign = false
      }
      const hide_query_result_btn = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].hide_query_result_btn
        : ''
      if (hide_query_result_btn == 1)
      {
        this.showJG = false
      } else
      {
        this.showJG = true
      }
      this.presigninfo = window['m' + this.moduleNo] ? window['m' + this.moduleNo].presigninfo : ''
      const sp = window['m' + this.moduleNo] ? window['m' + this.moduleNo].showemppic : ''
      const sp1 = window['m' + this.moduleNo] ? window['m' + this.moduleNo].showcappic1 : ''
      const sp2 = window['m' + this.moduleNo] ? window['m' + this.moduleNo].showcappic2 : ''
      if (sp == 1)
      {
        this.showemppic = true
      } else
      {
        this.showemppic = false
      }
      if (sp1 == 1)
      {
        this.showcappic1 = true
      } else
      {
        this.showcappic1 = false
      }
      if (sp2 == 1)
      {
        this.showcappic2 = true
      } else
      {
        this.showcappic2 = false
      }
      emppic_title = window['m' + this.moduleNo] ? window['m' + this.moduleNo].emppic_title : ''
      cappic1_title = window['m' + this.moduleNo] ? window['m' + this.moduleNo].cappic1_title : ''
      cappic2_title = window['m' + this.moduleNo] ? window['m' + this.moduleNo].cappic2_title : ''
      const ap = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].autoPost
        : ''
      if (ap == 1)
      {
        this.autoPost = true
      } else
      {
        this.autoPost = false
      }
      // 子表的附件名列表
      this.detailAtList = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].detailAtList
        : []
      const test_before_post = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].test_before_post
        : 1
      if (test_before_post == 1)
      {
        this.test_before_post = true
      } else
      {
        this.test_before_post = false
      }
      // 是否隐藏主表或者子表附件
      const hama = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].hide_all_master_atfile
        : ''
      if (hama == 1)
      {
        this.hide_all_master_atfile = true
      } else
      {
        this.hide_all_master_atfile = false
      }

      const last_page_show_post_btn = window['m' + this.moduleNo]
        ? window['m' + this.moduleNo].last_page_show_post_btn
        : ''
      if (last_page_show_post_btn == 1)
      {
        this.last_page_show_post_btn = true
      } else
      {
        this.last_page_show_post_btn = false
      }
      // 分页参数
      this.pageshow = window['m' + this.moduleNo] ? window['m' + this.moduleNo].pageshow : null
      // 如果没有就用全局参数
      if (!this.pageshow && this.pageshow != 0)
      {
        this.pageshow = window.pageshow
      }
      // 不允许更换主表/子表附件
      const changeMFile = window['m' + this.moduleNo] ? window['m' + this.moduleNo].can_not_change_master_file : ''
      if (changeMFile == 1)
      {
        this.can_not_change_master_file = true
      } else
      {
        this.can_not_change_master_file = false
      }
      this.nav_btn_caption = window['m' + this.moduleNo] ? window['m' + this.moduleNo].nav_btn_caption : ''
      // 点下一页提醒对应的字段必填
      const change_next_page_mustinput = window['m' + this.moduleNo] ? window['m' + this.moduleNo].change_next_page_mustinput : ''
      if (change_next_page_mustinput == 1)
      {
        this.change_next_page_mustinput = true
      } else
      {
        this.change_next_page_mustinput = false
      }
    }

    this.pic[0].show = this.showemppic
    this.pic[1].show = this.showcappic1
    this.pic[2].show = this.showcappic2
    this.pic[0].name = emppic_title ? emppic_title : '证件照'
    this.pic[1].name = cappic1_title ? cappic1_title : '自拍照1'
    this.pic[2].name = cappic2_title ? cappic2_title : '自拍照2'
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      // console.log('当前页面路由：' + to.path);
      // console.log('当前页面路由：' + to.query.showSeFormPop);
      if (to.query.showSeFormPop == true || to.query.showSeFormPop == 'true')
      {
        vm.showPop = true
      }
    })
  },
  methods: {
    // 将身份证识别头像赋值给头像证件照
    setIDCardphoToPic (base64) {
      if (this.showemppic)
      {
        // 将base64转file
        let filename = 'emp_' + new Date().getTime() + '.png'
        let arr = base64.split(',')
        let mime = arr[0].match(/:(.*?);/)[1] /*文件类型*/
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--)
        {
          u8arr[n] = bstr.charCodeAt(n)
        }
        let file = new File([u8arr], filename, { type: mime })
        // 赋值给头像证件照
        this.pic[0].src = base64
        this.pic[0].file = file
      }
    },
    // 获取wxForm的loopData
    getLoopData (data, usedicfilename, useMasterAtFile, otherAtFileList) {
      this.usedicfilename = usedicfilename
      this.useMasterAtFile = useMasterAtFile
      this.otherAtFileList = otherAtFileList
      // console.log(data, 'datadatadatadata');
      const loopData = data
      // 如果没有启用分页的话要显示头像信息
      if (this.pageshow != 1 || this.pageshow != '1')
      {
        this.showHead = true
      }
      // const fromData = this.$refs.wxForm.form
      this.menuList = []
      if (loopData.length > 0)
      {
        loopData.forEach((it, idx) => {
          let obj = {
            sqlNum: idx,
            name: it[0].appgroupname,
            from: 'main'
          }
          this.menuList.push(obj)
        })
      }
      if (
        this.moduleNo != '201' &&
        this.showEmppicture &&
        (this.showemppic || this.showcappic1 || this.showcappic2)
      )
      {
        this.menuList.push({
          sqlNum: 0,
          name: '头像信息',
          from: 'head'
        })
      }
      if (
        (!usedicfilename ||
          (usedicfilename && !useMasterAtFile) ||
          (usedicfilename && useMasterAtFile && otherAtFileList)) &&
        !this.hide_all_master_atfile
      )
      {
        this.menuList.push({
          sqlNum: 0,
          name: '附件信息',
          from: 'appendix'
        })
      }
      if (this.dttableinfo.length > 0)
      {
        this.dttableinfo.forEach((ele, index) => {
          let object = {
            sqlNum: index,
            name: ele.detailtbname,
            from: 'son'
          }
          this.menuList.push(object)
        })
      }
    },
    //  autoPost // 点击下一步或上一步（或左边切换时）是否启用自动保存，1保存，0不保存
    customSave () {
      if (this.pageshow == 1 && this.autoPost)
      {
        this.showOverlay = true
        this.$refs.wxForm.saveRsTempRecordData()
      }
    },
    // 上一步
    previousStep () {
      this.customSave()
      let timer = setInterval(() => {
        if (!this.showOverlay)
        {
          clearInterval(timer)
          const item = this.menuList[this.sidebarActive]
          // console.log(this.menuList, item.from)
          if (item.from == 'main')
          {
            //要判断第一条
            if (item.sqlNum == 0)
            {
              return
            } else
            {
              this.hiddenAll()
              // this.showPersonal = true
              // 隐藏提交按钮
              this.showSubmmitBtn = false
              this.$refs.wxForm.singleCroList[item.sqlNum - 1].show = true
              this.sidebarActive = this.sidebarActive - 1
            }
          } else if (item.from == 'head')
          {
            this.hiddenAll()
            // this.showPersonal = true // 个人信息头要展示
            const num = this.$refs.wxForm.singleCroList.length - 1
            this.$refs.wxForm.singleCroList[num].show = true
            // 隐藏提交按钮
            this.showSubmmitBtn = false
            this.sidebarActive = this.sidebarActive - 1
          } else if (item.from == 'appendix')
          {
            this.hiddenAll()
            // this.showPersonal = true // 个人信息头要展示
            if (
              this.moduleNo != '201' &&
              this.showEmppicture &&
              (this.showemppic || this.showcappic1 || this.showcappic2)
            )
            {
              this.showHead = true
            } else
            {
              const num = this.$refs.wxForm.singleCroList.length - 1
              this.$refs.wxForm.singleCroList[num].show = true
            }
            // 隐藏提交按钮
            this.showSubmmitBtn = false
            this.sidebarActive = this.sidebarActive - 1
          } else
          {
            this.hiddenAll()
            this.showSubmmitBtn = false
            this.sidebarActive = this.sidebarActive - 1
            //要判断子表第一条
            if (item.sqlNum == 0)
            {
              if (
                (!this.usedicfilename ||
                  (this.usedicfilename && !this.useMasterAtFile) ||
                  (this.usedicfilename &&
                    this.useMasterAtFile &&
                    this.otherAtFileList)) &&
                !this.hide_all_master_atfile
              )
              {
                // 表示有附件
                this.$refs.wxForm.showAppendix = true
              } else
              {
                // 没有附件就去判断头像
                if (
                  this.moduleNo != '201' &&
                  this.showEmppicture &&
                  (this.showemppic || this.showcappic1 || this.showcappic2)
                )
                {
                  this.showHead = true
                } else
                {
                  const num = this.$refs.wxForm.singleCroList.length - 1
                  this.$refs.wxForm.singleCroList[num].show = true
                }
              }
            } else
            {
              this.dttableinfo[item.sqlNum - 1].show = true
            }
          }

          // 如果子表没有记录则添加一条记录
          const activeItem = this.menuList[this.sidebarActive]

          if (
            activeItem.from == 'son' &&
            this.$refs.detail[activeItem.sqlNum].form &&
            this.$refs.detail[activeItem.sqlNum].form.length == 0
          )
          {
            let m_need_create_empty_record = window['m' + this.moduleNo]
              ? window['m' + this.moduleNo][
              'm' +
              this.$refs.detail[activeItem.sqlNum].info.moduleno +
              '_need_create_empty_record'
              ]
              : 1
            if (m_need_create_empty_record)
              this.$refs.detail[activeItem.sqlNum].add('0')
          }
        }
      }, 500)
    },
    // 检查当前页的必输
    async checkCurrentPageMuipt (ary) {
      let msg = false
      for (let k = 0; k < ary.length; k++)
      {
        let i = ary[k]
        if (
          i.mustinput &&
          (i.formdata == null || i.formdata == '') &&
          !(
            this.moduleConfig.canselmulti &&
            i.fieldname == this.moduleConfig.multifieldname &&
            this.status == 'save'
          )
        )
        {
          // this.$message({ type: 'error', message: i.chnname + ' 必填！' })
          Notify({
            type: 'danger',
            message: i.chnname + ' 必填！'
          })
          // this.$emit('changPage', o, 'main')
          msg = true
          return msg
        }

        //先触发退出提醒
        if (i.isexitshowinfo && i.formdata)
        {
          //启用退出提醒
          const totalformstr = JSON.stringify(this.$refs.wxForm.formstr)
          const editstate =
            this.acceptid === '' ||
              this.acceptid === null ||
              this.acceptid === '0' ||
              this.acceptid === 0
              ? 1
              : 2
          const data = {
            editstate: editstate,
            moduleno: this.moduleNo,
            fieldname: i.fieldname,
            fieldvalue: i.formdata,
            username: 'admin',
            formstr: totalformstr
          }
          let result = await this.$refs.wxForm.ExitInfo(data)
          // console.log(result, 'result');
          if (result)
          {
            msg = true
            return msg
          }
        }
      }
      return msg
    },
    // 下一步
    async nextStep () {
      let cmip = false
      if (this.change_next_page_mustinput)
      {
        let form = this.$refs.wxForm.form
        let sclist = this.$refs.wxForm.singleCroList
        let sqlNum = 0
        for (let s = 0; s < sclist.length; s++)
        {
          const ele = sclist[s]
          if (ele.show)
          {
            sqlNum = ele.sqlNum
            break
          }
        }
        let currentPageData = form ? form.loopData[sqlNum] : []
        cmip = await this.checkCurrentPageMuipt(currentPageData)
      }
      if (cmip)
      {
        return false
      }
      this.customSave()
      let timer = setInterval(() => {
        if (!this.showOverlay)
        {
          clearInterval(timer)
          const item = this.menuList[this.sidebarActive]
          // console.log(this.menuList, item.from)
          if (item.from == 'main')
          {
            //要判断主表最后一条
            if (item.sqlNum == this.$refs.wxForm.singleCroList.length - 1)
            {
              this.hiddenAll()
              // this.showPersonal = true // 个人信息头要展示
              // this.showHead = true
              if (
                this.moduleNo != '201' &&
                this.showEmppicture &&
                (this.showemppic || this.showcappic1 || this.showcappic2)
              )
              {
                this.showHead = true
                // 隐藏提交按钮
                this.showSubmmitBtn = false
                this.sidebarActive = this.sidebarActive + 1
              } else if (
                (!this.usedicfilename ||
                  (this.usedicfilename && !this.useMasterAtFile) ||
                  (this.usedicfilename &&
                    this.useMasterAtFile &&
                    this.otherAtFileList)) &&
                !this.hide_all_master_atfile
              )
              {
                // 表示有附件
                this.$refs.wxForm.showAppendix = true
                this.sidebarActive = this.sidebarActive + 1
                // 在附件的时候要判断有没有子表，如果没有就要显示提交按钮，否则要隐藏提交按钮
                if (this.dttableinfo.length > 0)
                {
                  this.showSubmmitBtn = false
                } else
                {
                  this.showSubmmitBtn = true
                }
              } else
              {
                // 没有附件就去子表
                if (this.dttableinfo.length > 0)
                {
                  this.showSubmmitBtn = false
                  this.dttableinfo[0].show = true
                  this.sidebarActive = this.sidebarActive + 1
                } else
                {
                  this.showSubmmitBtn = true
                }
              }
            } else
            {
              this.hiddenAll()
              // this.showPersonal = true
              // 隐藏提交按钮
              this.showSubmmitBtn = false
              this.$refs.wxForm.singleCroList[item.sqlNum + 1].show = true
              this.sidebarActive = this.sidebarActive + 1
            }
          } else if (item.from == 'head')
          {
            this.hiddenAll()
            if (
              (!this.usedicfilename ||
                (this.usedicfilename && !this.useMasterAtFile) ||
                (this.usedicfilename &&
                  this.useMasterAtFile &&
                  this.otherAtFileList)) &&
              !this.hide_all_master_atfile
            )
            {
              // 表示有附件
              this.$refs.wxForm.showAppendix = true
              this.sidebarActive = this.sidebarActive + 1
              // 在附件的时候要判断有没有子表，如果没有就要显示提交按钮，否则要隐藏提交按钮
              if (this.dttableinfo.length > 0)
              {
                this.showSubmmitBtn = false
              } else
              {
                this.showSubmmitBtn = true
              }
            } else
            {
              // 没有附件就去子表
              if (this.dttableinfo.length > 0)
              {
                this.showSubmmitBtn = false
                this.dttableinfo[0].show = true
                this.sidebarActive = this.sidebarActive + 1
              } else
              {
                this.showSubmmitBtn = true
              }
            }
          } else if (item.from == 'appendix')
          {
            // this.showPersonal = false // 个人信息头要隐藏
            this.hiddenAll()
            this.dttableinfo[item.sqlNum].show = true
            this.sidebarActive = this.sidebarActive + 1
            if (item.sqlNum == this.dttableinfo.length - 1)
            {
              // 要显示提交按钮
              this.showSubmmitBtn = true
            }
          } else
          {
            //要判断倒数第二条
            if (item.sqlNum == this.dttableinfo.length - 2)
            {
              // this.showPersonal = false // 个人信息头要隐藏
              this.hiddenAll()
              this.dttableinfo[item.sqlNum + 1].show = true
              this.sidebarActive = this.sidebarActive + 1
              // 要显示提交按钮
              this.showSubmmitBtn = true
            } else
            {
              // this.showPersonal = false // 个人信息头要隐藏
              this.hiddenAll()
              this.dttableinfo[item.sqlNum + 1].show = true
              this.sidebarActive = this.sidebarActive + 1
            }
          }
          // 如果子表没有记录则添加一条记录
          const activeItem = this.menuList[this.sidebarActive]
          if (
            activeItem.from == 'son' &&
            this.$refs.detail[activeItem.sqlNum].form &&
            this.$refs.detail[activeItem.sqlNum].form.length == 0
          )
          {
            let m_need_create_empty_record = window['m' + this.moduleNo]
              ? window['m' + this.moduleNo][
              'm' +
              this.$refs.detail[activeItem.sqlNum].info.moduleno +
              '_need_create_empty_record'
              ]
              : 1
            if (m_need_create_empty_record)
              this.$refs.detail[activeItem.sqlNum].add('0')
          }
        }
      }, 500)
    },

    // 隐藏所有信息
    hiddenAll () {
      // 主表
      this.$refs.wxForm.singleCroList.forEach(e => {
        e.show = false
      })
      // 头像信息
      this.showHead = false
      // 附件信息
      this.$refs.wxForm.showAppendix = false
      // 子表信息
      this.dttableinfo.forEach(el => {
        el.show = false
      })
    },
    // 点击左侧导航
    async changMenu (item) {
      let acindex = this.sidebarActive
      let cmip = false
      if (this.change_next_page_mustinput)
      {
        let form = this.$refs.wxForm.form
        let sclist = this.$refs.wxForm.singleCroList
        let sqlNum = 0
        for (let s = 0; s < sclist.length; s++)
        {
          const ele = sclist[s]
          if (ele.show)
          {
            sqlNum = ele.sqlNum
            break
          }
        }
        let currentPageData = form ? form.loopData[sqlNum] : []
        cmip = await this.checkCurrentPageMuipt(currentPageData)
      }
      if (cmip)
      {
        setTimeout(() => {
          this.sidebarActive = acindex
        }, 300);
        // 最后都要关闭导航
        this.showMenu = false
        return false
      }
      this.customSave()
      let timer = setInterval(() => {
        if (!this.showOverlay)
        {
          clearInterval(timer)
          if (item.from == 'main')
          {
            // 控制主表
            this.hiddenAll()
            // this.showPersonal = true // 个人信息头要展示
            this.$refs.wxForm.singleCroList[item.sqlNum].show = true
            // 隐藏提交按钮
            this.showSubmmitBtn = false
          } else if (item.from == 'head')
          {
            this.hiddenAll()
            // this.showPersonal = true // 个人信息头要展示
            this.showHead = true
            // 隐藏提交按钮
            this.showSubmmitBtn = false
          } else if (item.from == 'appendix')
          {
            this.hiddenAll()
            // this.showPersonal = true // 个人信息头要展示
            this.$refs.wxForm.showAppendix = true
            // 在附件的时候要判断有没有子表，如果没有就要显示提交按钮，否则要隐藏提交按钮
            if (this.dttableinfo.length > 0)
            {
              this.showSubmmitBtn = false
            } else
            {
              this.showSubmmitBtn = true
            }
          } else
          {
            // this.showPersonal = false // 个人信息头要隐藏
            this.hiddenAll()
            this.dttableinfo[item.sqlNum].show = true
            // 判断是不是点击的子表最后一条记录，是的话要显示提交按钮
            if (item.sqlNum == this.dttableinfo.length - 1)
            {
              this.showSubmmitBtn = true
            } else
            {
              this.showSubmmitBtn = false
            }
            // 如果子表没有记录则添加一条记录
            if (
              this.$refs.detail[item.sqlNum].form &&
              this.$refs.detail[item.sqlNum].form.length == 0
            )
            {
              let m_need_create_empty_record = window['m' + this.moduleNo]
                ? window['m' + this.moduleNo][
                'm' +
                this.$refs.detail[item.sqlNum].info.moduleno +
                '_need_create_empty_record'
                ]
                : 1
              if (m_need_create_empty_record)
                this.$refs.detail[item.sqlNum].add('0')
            }
            this.$forceUpdate()
          }
        }
      }, 500)
      // 最后都要关闭导航
      this.showMenu = false
      this.$forceUpdate()
    },
    // 主表必填字段为空或者子表保存前提示报错，跳转到指定页面
    changPage (index, from) {
      console.log(index, from, 'changPage')

      if (this.pageshow == 1 || this.pageshow == '1')
      {
        let i = 0
        this.menuList.forEach((e, k) => {
          if (e.from == from)
          {
            if (i == index)
            {
              this.sidebarActive = k
              this.changMenu(e)
            }
            i++
          }
        })
      }
    },
    // 刷新子表信息
    refreshSonData () {
      getbaseforminfo({
        moduleno: this.moduleNo,
        userid: '1',
        langid: 0,
        flag: 0
      })
        .then(res => {
          if (res.iserror === '0')
          {
            // this.baseinfo = res
            // this.moduleConfig = res.moduleconfiginfo[0] // 模块配置信息
            this.dttableinfo = res.dttableinfo.filter(item => item.dt_appshow) //子表
            this.dttableinfo.forEach((el, idx) => {
              el.key = new Date().getTime() + '_' + idx
              if (this.pageshow == 1 || this.pageshow == '1')
              {
                el.show = false
              } else
              {
                el.show = true
              }
            })
            // this.attableinfo = res.attableinfo //附表

            if (sessionStorage.station)
            {
              this.treeNode = JSON.parse(sessionStorage.station) || {}
            }
            // console.log(this.dttableinfo, this.attableinfo, 1111)
          }
        })
        .finally(() => {
          // this.loading = false
        })
    },
    // 获取基本信息
    getBaseForm () {
      // this.loading = true
      // Cookies.set('langid','0')
      getbaseforminfo({
        moduleno: this.moduleNo,
        userid: '1',
        langid: 0,
        flag: 0
      })
        .then(res => {
          if (res.iserror === '0')
          {
            this.baseinfo = res
            this.moduleConfig = res.moduleconfiginfo[0] // 模块配置信息
            this.dttableinfo = res.dttableinfo.filter(item => item.dt_appshow) //子表
            this.dttableinfo.forEach((el, idx) => {
              el.key = new Date().getTime() + '_' + idx
              if (this.pageshow == 1 || this.pageshow == '1')
              {
                el.show = false
              } else
              {
                el.show = true
              }
            })
            // this.attableinfo = res.attableinfo //附表

            if (sessionStorage.station)
            {
              this.treeNode = JSON.parse(sessionStorage.station) || {}
            }
            // console.log(this.dttableinfo, this.attableinfo, 1111)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getFormRecordData (data, acceptid) {
      this.acceptid = acceptid
      if (this.sign !== null)
      {
        if (this.moduleNo == '201')
        {
          // 保存审批流签名
          upLoadBase64FileFixName({
            moduleno: this.moduleNo,
            upflag: '7',
            autoid: this.localuserid,
            uploadpath: 'WorkFlow/UserSign',
            username: 'admin',
            filename: `user_${this.localuserid}.png`,
            fileext: 'png',
            filebase64str: this.signstr
          })
        }
        // 存在签名，保存签名附件
        this.$refs.wxForm.uploadfile(this.sign, false)
      }

      this.pic.forEach(e => {
        if (e.file)
        {
          // 设置了头像 需要上传
          const filename = `${e.type === 1
            ? 'emp'
            : e.type === 2
              ? 'cap1'
              : e.type === 3
                ? 'cap2'
                : ''
            }_${acceptid}.jpg`
          this.$refs.wxForm.upLoadBase64(e.file, filename)
        }
      })

      if (this.$refs.detail)
      {
        //批量保存子表
        this.$refs.detail.forEach(d => {
          d.setMautoid(acceptid)
        })
        this.$nextTick(() => {
          this.$refs.detail.forEach(d => {
            d.save()
          })
        })
      }
      // this.$message({ type: 'success', message: '保存成功' })
      Notify({
        type: 'success',
        message: '保存成功'
      })
      this.btnLoad = false
      // 提交前的全局提醒过程
      beforePostScanEntry({
        moduleno: this.moduleNo,
        autoid: acceptid
      }).then(res => {
        if (res.data[0].info)
        {
          Notify({
            type: 'danger',
            message: res.data[0].info
          })
        } else
        {
          this.postmsg = res.data[0].postmsg
          this.showPop = true
          this.empName = this.$refs.wxForm.formstr.empname
        }
      })
      // console.log(this.$refs.wxForm.formstr.empname, 'datadatadatadata');
      // 304 是否提交后问卷调查
      if (this.test_before_post == false)
      {
        const sta = JSON.parse(sessionStorage.getItem('station'))
        // 检查获取招聘考试信息
        getScanTestPaperInfo({
          rsid: this.acceptid,
          stationid: sta.stationid,
          username: this.tel //'admin'
        }).then(rs => {
          let data = rs.data[0]
          if (data.test_type_id == 0)
          {
            // 走问卷
            checkWxRsInputStatus({
              moduleno: this.moduleNo,
              telephone: this.tel,
              pageshow: this.pageshow,
              autoPost: this.autoPost,
              crman: 'system_wx'
            }).then(res => {
              // 检查是否做过问卷
              if (res.data[0].istest)
              {
                // 做过就不管
              } else
              {
                // 没有做过就查询问卷
                const sta = JSON.parse(sessionStorage.getItem('station'))
                getQsTemplateOptionList_stationid({
                  stationid: sta.stationid
                }).then(res => {
                  if (res.baseinfo.length > 0 || res.data.length > 0)
                  {
                    // 表示有问卷数据，需要跳转到问卷页面
                    let qd = {
                      baseinfo: [],
                      data: []
                    }
                    qd.baseinfo = res.baseinfo
                    qd.data = res.data
                    localStorage.setItem('questionData', JSON.stringify(qd))
                    // 跳转到问卷页面
                    const param = {
                      module: this.moduleNo,
                      restype: this.restype,
                      tel: this.tel,
                      tj_empid: sessionStorage.getItem('tj_empid'),
                      istest: sessionStorage.getItem('istest'),
                      attachfilepath: sessionStorage.getItem('attachfilepath'),
                      autoid: this.acceptid, //this.$route.query.autoid
                      mode: this.mode
                    }
                    this.$router.push({
                      path: '/questionnaire',
                      query: { param: Base64.encode(JSON.stringify(param)) }
                    })
                    // this.$router.push({
                    //   path: '/questionnaire',
                    //   query: {
                    //     module: this.moduleNo,
                    //     restype: this.restype,
                    //     tel: this.tel,
                    //     tj_empid: sessionStorage.getItem('tj_empid'),
                    //     istest: sessionStorage.getItem('istest'),
                    //     attachfilepath: sessionStorage.getItem(
                    //       'attachfilepath'
                    //     ),
                    //     autoid: this.acceptid //this.$route.query.autoid
                    //   }
                    // })
                  }
                })
              }
            })
          } else
          {
            // 走考试
            checkZpTestRes({
              rsid: this.acceptid,
              teststyle: '投递'
            }).then(result => {
              if (result.data[0].info == 'N')
              {
                // this.$router.push({
                //   path: '/examinInfo',
                //   query: {
                //     module: this.moduleNo,
                //     restype: this.restype,
                //     tel: this.tel,
                //     tj_empid: sessionStorage.getItem('tj_empid'),
                //     istest: sessionStorage.getItem('istest'),
                //     attachfilepath: sessionStorage.getItem('attachfilepath'),
                //     paperid: data.test_paperid,
                //     mautoid: this.acceptid,
                //     teststyle: '投递',
                //     empid: 0,
                //     username: this.tel,
                //     from: ''
                //   }
                // })
                const param = {
                  module: this.moduleNo,
                  restype: this.restype,
                  tel: this.tel,
                  tj_empid: sessionStorage.getItem('tj_empid'),
                  istest: sessionStorage.getItem('istest'),
                  attachfilepath: sessionStorage.getItem('attachfilepath'),
                  paperid: data.test_paperid,
                  mautoid: this.acceptid,
                  teststyle: '投递',
                  empid: 0,
                  username: this.tel,
                  from: '',
                  mode: this.mode
                }
                this.$router.push({
                  path: '/examinInfo',
                  query: { param: Base64.encode(JSON.stringify(param)) }
                })
              }
            })
          }
        })
      }
    },

    // 在执行点击下一步或上一步（或左边切换）时保存数据后回到父组件
    async callBackFormRecordData (acceptid) {
      this.acceptid = acceptid
      // 保存头像
      // this.pic.forEach(e => {
      //   if (e.file)        {
      //     // 设置了头像 需要上传
      //     const filename = `${
      //       e.type === 1
      //         ? 'emp'
      //         : e.type === 2
      //           ? 'cap1'
      //           : e.type === 3
      //             ? 'cap2'
      //             : ''
      //       }_${acceptid}.jpg`
      //     this.$refs.wxForm.upLoadBase64(e.file, filename)
      //   }
      // })
      // console.log(this.$refs.detail, 'this.$refs.detail');

      //批量保存子表
      if (this.$refs.detail)
      {
        this.$refs.detail.forEach(d => {
          d.setMautoid(acceptid)
        })
        await this.$nextTick(() => {
          this.$refs.detail.forEach(d => {
            d.saveTemporaryData()
          })
        })
      }
      this.showOverlay = false
    },
    // 保存成功后关闭按钮
    colsePage () {
      window.close()
      WeixinJSBridge.invoke('closeWindow', {}, function (res) { })
    },
    writeSysTips (data) {
      // this.$message.error('data')
      Notify({
        type: 'danger',
        message: data
      })
    },
    get () { },
    updateformstr () { },
    setCanSave () {
      this.btnLoad = false
    },
    save () {
      this.$refs.wxForm.singleSel = true
      this.btnLoad = true
      let cmip = this.checkmustinput() // 所有表单的必填判断
      if (cmip)
      {
        //this.ask('请填写必填项')
        this.setCanSave(true)
        return false
      } else
      {
        // return this.beforeAction()
        let json = {}
        this.dttableinfo.forEach((e, i) => {
          json['#recordcount_m' + e.moduleno + '#'] = this.$refs.detail[
            i
          ].getCount()
          json['#filecount_m' + e.moduleno + '#'] = this.$refs.detail[
            i
          ].getFileCount()
        })
        // 主表附件数 添加到formstr
        if (this.$refs.wxForm.usedicfilename)
        {
          // 主表每个字典附件
          this.$refs.wxForm.fileList.forEach((e, i) => {
            json['#masterfilecount_' + e.name] = e.url != null ? 1 : 0
          })
        } else
        {
          json['#masterfilecount_total'] = this.$refs.wxForm.fileList.length
        }

        // 允许主表附加字典类别显示 允许字典附件在某个主表后显示
        if (
          this.$refs.wxForm.usedicfilename &&
          this.$refs.wxForm.useMasterAtFile
        )
        {
          let loopData = this.$refs.wxForm.form.loopData
          loopData.forEach(ld => {
            if (ld.fileList && ld.fileList.length > 0)
            {
              ld.fileList.forEach(it => {
                json['#masterfilecount_' + it.name] = it.url != null ? 1 : 0
              })
            }
          })
        }

        if (this.showEmppicture)
        {
          // 员工照片
          this.pic.forEach(e => {
            const filename = `#masterfilecount_${e.type === 1
              ? 'emp'
              : e.type === 2
                ? 'cap1'
                : e.type === 3
                  ? 'cap2'
                  : ''
              }`
            json[filename] = e.file != null ? 1 : 0
          })
        }

        return this.$refs.wxForm.beforeAction(json)
      }
    },

    async b4save () {
      //20230816 在提交前，判断当前是否子表，如果是子表先走一次临时保存
      if (this.$refs.detail)
      {
        await this.dttableinfo.forEach(async (d, i) => {
          if (d.show)
          {
            await this.$refs.detail[i].saveTemporaryData()
          }
        })

        await this.attableinfo.forEach(async (d, i) => {
          if (d.show)
          {
            await this.$refs.detail[
              i + this.dttableinfo.length
            ].saveTemporaryData()
          }
        })
      }
      // 如果需要签名，则先走一次保存前判断，检查是否需要提示再弹出签名框
      if (this.usepresign)
      {
        this.$refs.wxForm.singleSel = true
        let cmip = this.checkmustinput() // 所有表单的必填判断
        if (!cmip)
        {
          let json = {}
          this.dttableinfo.forEach((e, i) => {
            json['#recordcount_m' + e.moduleno + '#'] = this.$refs.detail[
              i
            ].getCount()
            json['#filecount_m' + e.moduleno + '#'] = this.$refs.detail[
              i
            ].getFileCount()
          })
          // 主表附件数 添加到formstr
          if (this.$refs.wxForm.usedicfilename)
          {
            // 主表每个字典附件
            this.$refs.wxForm.fileList.forEach((e, i) => {
              json['#masterfilecount_' + e.name] = e.url != null ? 1 : 0
            })
          } else
          {
            json['#masterfilecount_total'] = this.$refs.wxForm.fileList.length
          }
          // 允许主表附加字典类别显示 允许字典附件在某个主表后显示
          if (
            this.$refs.wxForm.usedicfilename &&
            this.$refs.wxForm.useMasterAtFile
          )
          {
            let loopData = this.$refs.wxForm.form.loopData
            loopData.forEach(ld => {
              if (ld.fileList && ld.fileList.length > 0)
              {
                ld.fileList.forEach(it => {
                  json['#masterfilecount_' + it.name] = it.url != null ? 1 : 0
                })
              }
            })
          }
          if (this.showEmppicture)
          {
            // 员工照片
            this.pic.forEach(e => {
              const filename = `#masterfilecount_${e.type === 1
                ? 'emp'
                : e.type === 2
                  ? 'cap1'
                  : e.type === 3
                    ? 'cap2'
                    : ''
                }`
              json[filename] = e.file != null ? 1 : 0
            })
          }
          let onlycheck = true
          await this.$refs.wxForm
            .beforeAction(json, onlycheck)
            .then(res => {
              cmip = !res
              if (!cmip)
              {
                this.b4checkDetail(this.showQM)
              }
            })
            .catch(err => { })
          // this.show = true
        }
      } else
      {
        this.b4checkDetail(this.save)
      }
    },
    // 保存前子表判断
    async b4checkDetail (done) {
      let cmip = false
      // 获取主表的字段列表
      let params = {} // 用来提交前需要判断子表所有数据合法性的接口参数
      let mainData = this.$refs.wxForm.form.loopData
      let mainAry = []
      let obj = {}
      mainData.forEach(it => {
        it.forEach(el => {
          obj[el.fieldname] = el.formdata
        })
      })
      mainAry.push(obj)
      params.moduleno = this.moduleNo
      params[`m` + this.moduleNo] = mainAry

      // 子表保存前过程先走 一遍
      if (this.$refs.detail)
      {
        for (let idx = 0; idx < this.$refs.detail.length; idx++)
        {
          const d = this.$refs.detail[idx]
          // 获取子表的字段列表
          let wxforms = d.$refs.wxForm
          const moduleno = ''
          const sonForms = []
          if (wxforms)
          {
            wxforms.forEach(item => {
              moduleno = item.moduleno
              const loopData = item.form.loopData[0]
              let obj = {}
              loopData.forEach(ele => {
                obj[ele.fieldname] = ele.formdata
              })
              sonForms.push(obj)
            })
          }
          if (sonForms.length > 0)
          {
            params[`m` + moduleno] = sonForms
          }
        }
        // 调接口判断所有子表数据
        beforePostAllDtRecord(params).then(async res => {
          let result = res.data[0]
          if (result.isinfo)
          {
            if (result.cansave)
            {
              Dialog.confirm({
                message: result.info
              })
                .then(async () => {
                  // 继续后续操作
                  for (
                    let index = 0;
                    index < this.$refs.detail.length;
                    index++
                  )
                  {
                    const d = this.$refs.detail[index]
                    await d
                      .beforeAction()
                      .then(res => {
                        cmip = res
                      })
                      .catch(err => { })
                    if (cmip)
                    {
                      break
                    }
                  }
                  if (!cmip)
                  {
                    done()
                  }
                })
                .catch(() => { })
            } else
            {
              // 当 isinfo=true且cansave=false则直接弹窗提示，并终止操作
              Dialog.alert({
                message: result.info
              }).then(() => { })
            }
          } else
          {
            // 继续后续操作
            for (let index = 0; index < this.$refs.detail.length; index++)
            {
              const d = this.$refs.detail[index]
              await d
                .beforeAction()
                .then(res => {
                  cmip = res
                })
                .catch(err => { })
              if (cmip)
              {
                break
              }
            }
            if (!cmip)
            {
              done()
            }
          }
        })
        // 继续后续操作
        // for (let index = 0; index < this.$refs.detail.length; index++)        {
        //   const d = this.$refs.detail[index]
        //   await d
        //     .beforeAction()
        //     .then(res => {
        //       cmip = res
        //     })
        //     .catch(err => { })
        //   if (cmip)          {
        //     break
        //   }
        // }
        // if (!cmip)        {
        //   done()
        // }
      } else
      {
        done()
      }
    },
    // 判断所有表单都填了必填字段
    checkmustinput () {
      let cmip = this.$refs.wxForm.checkmustinput()
      if (this.$refs.detail && !cmip)
      {
        try
        {
          this.$refs.detail.forEach(d => {
            cmip = d.checkmustinput()
            if (cmip) throw new Error(cmip)
          })
        } catch (e)
        {
          cmip = true
        }
      }
      return cmip
    },
    showQM () {
      this.show = true
    },
    closeSpad () {
      this.show = false
    },
    // 签名文件的base64字符串
    getSpad (base64data) {
      this.signstr = base64data
      this.sign = dataURLtoFile(base64data, 'sign.png')
      this.closeSpad()
      this.save()
    },
    onOversize (file) {
      // console.log(file);
      // this.$message.error('文件大小不能超过 10M')
      Notify({
        type: 'danger',
        message: '文件大小不能超过 10M'
      })
    },
    // 打开上传头像
    openUpload (pic) {
      if (this.can_not_change_master_file && pic.file)
      {
        return
      }
      this.selPic = pic
      let select = false
      //emppic_select: 证件照是否允许从相册选取（1允许，0不允许，如果未设置默认不允许）
      //cappic1_select:自拍照1是否允许从相册选取（1允许，0不允许，如果未设置默认不允许）
      //cappic2_select:自拍照2是否允许从相册选取（1允许，0不允许，如果未设置默认不允许）
      let obj = {}
      if (isNaN(Number(this.moduleNo)))
      {
        // 不是数字
        obj = window.comm ? window.comm : {}
      } else
      {
        // 是数字
        obj = window['m' + this.moduleNo] ? window['m' + this.moduleNo] : {}
      }
      if (pic.type == 1 && obj.emppic_select)
      {
        select = obj.emppic_select == 1
      } else if (pic.type == 2 && obj.cappic1_select)
      {
        select = obj.cappic1_select == 1
      } else if (pic.type == 3 && obj.cappic2_select)
      {
        select = obj.cappic2_select == 1
      }
      this.capture = select ? null : 'camera'
      this.$nextTick(() => {
        this.$refs.uploader.chooseFile()
      })
    },
    // 选择图片后，判断是否需要修改命名
    beforeRead (file) {
      this.$refs.wxForm.getBase64(file).then(res => {
        this.selPic.src = res
        this.selPic.file = file
      })
      return false
    },
    // 设置头像
    setTx (type, url, sfilename, fileext) {
      this.pic.forEach(e => {
        if (e.type === type)
        {
          e.src = url
          e.sfilename = sfilename
          e.fileext = fileext
        }
      })
    },
    // 删除头像
    del (e) {
      if (e.sfilename)
      {
        this.$refs.wxForm.deletefile(e)
        e.sfilename = null
        e.fileext = null
      }
      e.file = null
      e.src = null
    },

    // 查看结果
    showResult () {
      this.showPop = false
      // let obj = Object.assign(this.$route.query, { 'autoid': this.acceptid })
      // console.log(obj, 'this.$route.query');
      // let redirect =
      //   '/seForm?module=' +
      //   obj.module +
      //   '&zpacid=' +
      //   obj.zpacid
      // const r =
      //   redirect +
      //   '&tel=' +
      //   obj.tel +
      //   '&attachfilepath=' +
      //   obj.attachfilepath +
      //   '&autoid=' +
      //   obj.autoid +
      //   '&restype=' +
      //   obj.restype +
      //   '&tj_empid=' +
      //   obj.tj_empid
      // this.$router.push(r)
      // // this.$router.replace('/seForm')
      // this.$router.replace({
      //   path: '/seForm',
      //   query: obj
      // }
      // 如果启用分页的话要显示第一条
      if (this.pageshow == 1 || this.pageshow == '1')
      {
        this.hiddenAll()
        this.$refs.wxForm.singleCroList[0].show = true
        // 隐藏提交按钮
        this.showSubmmitBtn = false
        this.sidebarActive = 0
      }
    },
    // 导入历史签名
    setSign (url) {
      // alert(url)
      this.$refs.signaturePad.setSign(url)
      // var url = u + '?v=' + Date.parse(new Date())
      // let img = new Image()
      // img.src = url
      // img.onload = () => {
      //   //判断图片是否加载成功
      // }
    }
  }
}
</script>

<style scoped lang="less">
.page {
  height: 100vh;

  .sava_Overlay {
    .wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .loading {
    position: absolute;
    padding-top: 75%;
    padding-left: 45%;
    z-index: 1111;
  }
  //ios微信端上下滑动页面，若触摸的是input区域，页面内不滚动，整个页面被拖动了
  -webkit-overflow-scrolling: touch;
  .pp {
    // height: 100%;
    height: calc(100% - 110px);
    padding-bottom: 106px;
    position: relative;
    overflow: auto;
    .register_title {
      font-size: 5vw;
      color: #303133;
      height: 11.46667vw;
      line-height: 11.46667vw;
      text-align: center;
      // border-bottom: 0.13333vw solid #eee;
      border-bottom: 0.13333vw solid #bababc;
      position: relative;
      width: 100%;
      background: #fff;
      .tx {
        border: 1px solid #666;
      }
      .round {
        border-radius: 50%;
      }
    }
    .register_title:before {
      content: "";
      position: absolute;
      width: 2.66667vw;
      height: 11.46667vw;
      left: -1.33333vw;
      top: 0;
      bottom: 0;
      background-color: #287eff;
      border-radius: 1.33333vw;
    }

    .input_box {
      width: 100vw;
      margin: 0 auto;
      /deep/ .iptline {
        margin: 0;
        padding: 0 4vw 0 24vw;
        font-size: 3.46vw;
        position: relative;
        min-height: 12.53vw;
        line-height: 12.53vw;
        position: relative;
        box-sizing: border-box;
        label {
          position: absolute;
          margin-left: -20vw;
          font-size: 3.46vw;
          color: #666;
        }
        .list {
          height: 10vw;
          // border-bottom: 0.13333vw solid #eee;
          line-height: 10vw;
          font-size: 4.26667vw;
          .listItem {
            padding: 0 4vw;
            position: relative;
            .icon-right {
              position: absolute;
              right: 2.66667vw;
              font-size: 5.33333vw;
              color: #ccc;
            }
          }
        }
        .headerImg {
          height: 21.133333vw;
          line-height: 21.133333vw;
          position: relative;
          .upload_demo {
            display: inline-block;
            /deep/ .el-upload-list {
              display: none !important;
            }
            img,
            svg.photo {
              position: absolute;
              top: 1.86667vw;
              right: 10.66667vw;
              width: 17.06667vw;
              height: 17.06667vw;
            }
          }
        }
      }
      /deep/ .iptline:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 2.66vw;
        right: 2.66vw;
        height: 1px;
        // border-top: 0.13333vw solid #eee;
        border-top: 0.13333vw solid #bababc;
      }
      .empPic {
        padding: 10px 0 20px;
        .right_titlepar {
          // border-bottom: 1px solid #ccc;
          border-bottom: 1px solid #bababc;
          // #bababc
          padding: 0 4vw;
          .right_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 5vw;
            min-height: 11.46667vw;
            .van-icon {
              border: 1px solid #999;
              padding: 5px;
            }
            .round {
              border-radius: 50%;
            }
            // line-height: 11.46667vw;
            .lump {
              height: 3vw;
              width: 1vw;
              // background: $active-color;
              display: inline-block;
              margin-right: 1vw;
            }
            .titlebtn {
              background: none;
              border: none;
              font-size: 20px;
            }
            .titlebtn:hover {
              background: none;
              border: none;
              // color: $active-color;
            }
          }
        }
        .picbox {
          padding: 10px 0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          div {
            font-size: 30px;
            text-align: center;
            position: relative;
            .van-uploader__preview-delete {
              position: absolute;
              right: 0;
              top: 0;
              z-index: 1;
              .van-icon {
                font-size: 14px;
                color: #fff;
                position: absolute;
                right: 5px;
                top: 7px;
                z-index: 1;
              }
            }
          }
        }
      }
    }
  }
  .page_bottom {
    z-index: 1999;
    position: fixed;
    bottom: 0;
    width: 100vw;
    background: #fff;
    height: 14vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .addWidth {
      width: 25vw;
    }
    .van-button {
      height: 10vw;
      border-radius: 1vw;
      font-size: 32px;
    }
    .Sed {
      // width: 84vw;
      // margin: 2vw auto;
      background-color: #247dff;
      // border-radius: 0.5vw;
      display: flex;
      align-items: center;
      justify-content: center;
      // font-size: 4.8vw;
      letter-spacing: 0.267vw;
      color: #ffffff;
      opacity: 0.4;
    }
    .op {
      opacity: 1 !important;
    }
  }
  .bottom {
    z-index: 1999;
    position: fixed;
    bottom: 0;
    width: 100vw;
    background: #fff;
    height: 14vw;
    .Sed {
      width: 84vw;
      height: 10vw;
      margin: 2vw auto;
      background-color: #247dff;
      border-radius: 0.5vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 4.8vw;
      letter-spacing: 0.267vw;
      color: #ffffff;
      opacity: 0.4;
    }
    .op {
      opacity: 1 !important;
    }
  }
}
.success_pop {
  .contant {
    height: 100%;
    .suc_header {
      height: 90px;
      line-height: 90px;
      background-color: #2b8df0;
      color: #ffffff;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
    }
    .suc_image {
      height: 50%;
      text-align: center;
      padding: 50px 0;
      img {
        margin-top: 40px;
      }
    }
    .suc_name {
      color: #333333;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      :first-child {
        color: #2b8df0;
        margin-right: 20px;
      }
    }
    .wuyong {
      color: #333333;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      padding: 30px 0;
    }
    .footer_btn {
      width: 100%;
      position: absolute;
      bottom: 40px;
      .result_btn {
        text-align: center;
        .van-button {
          height: 80px;
          width: 35%;
          border-radius: 12px;
          .van-button__content {
            font-size: 28px;
            font-weight: bold;
          }
        }
      }
      .colser_btn {
        padding: 20px 0;
        text-align: center;
        color: #999;
        font-size: 28px;
        font-weight: bold;
        span {
          padding: 20px 40px;
        }
      }
    }
  }
}

.showMenuPop {
  .sidContent {
    padding: 30px;
    .van-sidebar {
      width: 100%;
      overflow-y: unset;
      .noMain_sid {
        background-color: #e9f3fe;
      }
      .main_sid {
        background-color: #d4e8fc;
      }
      .has_divider {
        // border-top: 2px solid red;
        margin-top: 30px;
      }
      .van-sidebar-item--select {
        color: #2b8df0;
        background-color: #fff !important;
      }
      .van-sidebar-item--select::before {
        background-color: #2b8df0;
      }
    }
  }
}
</style>
